import type { UseQueryResult } from "@edreamsodigeo/frontend-api-client";
import { useQuery } from "@edreamsodigeo/frontend-api-client";

import type {
  GetMembershipProductRequest,
  MembershipProductQuery,
  MembershipProductQueryVariables,
} from "~/generated/graphql";
import { GET_MEMBERSHIP_PRODUCT } from "../providers/operations/membershipProduct";
import { isValidShoppingId, useShoppingInfo } from "./useShoppingInfo";

const useMembershipProductQuery = (): UseQueryResult<
  MembershipProductQuery,
  MembershipProductQueryVariables
> => {
  const shoppingInfo = useShoppingInfo();
  const membershipProductRequest: GetMembershipProductRequest = {
    shoppingInfo,
  };
  const skipQuery = !isValidShoppingId(shoppingInfo.shoppingId);
  return useQuery<MembershipProductQuery, MembershipProductQueryVariables>(
    GET_MEMBERSHIP_PRODUCT,
    {
      variables: {
        membershipProductRequest,
      },
      skip: skipQuery,
    },
  );
};

export default useMembershipProductQuery;
